import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ResendReleasePaymentHoldCont from "presentation/view/container/ResendReleasePaymentHold/ResendReleasePaymentHoldCont";

CommonEntrypoint(<ResendReleasePaymentHoldCont />)